export const ITEM_TYPES: any[] = [
  {
    id: "Barge",
    name: "Barge",
  },
  {
    id: "Coaster",
    name: "Coaster",
  },
  {
    id: "Container",
    name: "Container",
  },
  {
    id: "Item",
    name: "Item",
  },
  {
    id: "Lot",
    name: "Lot",
  },
  {
    id: "Shoretank",
    name: "Shoretank",
  },
  {
    id: "Tank",
    name: "Tank",
  },
  {
    id: "Wagon",
    name: "Wagon",
  },
  {
    id: "Vehicle",
    name: "Vehicle",
  },
  {
    id: "Vessel",
    name: "Vessel",
  },
  {
    id: "Truck",
    name: "Truck",
  },
];
